import Papa from 'papaparse';
import _ from 'lodash';

import { START_CSV_PROCESSING, END_CSV_PROCESSING, ADD_CSV_PROCESSING_RESULT, INITIALIZE_CSV_PROCESSING_RESULTS, CLEAR_CSV_PROCESSING_RESULTS } from '../constants/actionTypes';
import { NEW_IMPORTED_ITEM, UPDATE_IMPORTED_ITEM, NOOP_IMPORTED_ITEM } from '../constants/csvImportTypes';
import { displayError } from './helpers';
import { addMedia } from './addMedia';
import { updateMedia } from './updateMedia';
import { fetchMediaIfOK } from './fetchMedia';

// Action Creators
const startCsvProcessing = () => ({
    type: START_CSV_PROCESSING
});

const endCsvProcessing = () => ({
    type: END_CSV_PROCESSING
});

const addCsvProvessingResult = result => ({
    type: ADD_CSV_PROCESSING_RESULT,
    result: result
});

const initializeCsvProcessingResults = totalCount => ({
    type: INITIALIZE_CSV_PROCESSING_RESULTS,
    totalCount: totalCount
});

export const clearCsvProcessingResults = () => ({
    type: CLEAR_CSV_PROCESSING_RESULTS
});

// Action Logic
const canHandleProcessing = state => {
    return !state.isProcessing;
};

const readFile = file => {
    // Read the binary of the file but its events, so we need to map that into a promise.
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.addEventListener('loadend', () => {
            resolve(reader.result);
        });
        reader.addEventListener('error', () => {
            reject('failed to read uploaded csv');
        });

        reader.readAsText(file);
    });
};

const parseCsvRows = data => {
    return Papa.parse(data, {
        header: true,
        dynamicTyping: true
    });
};

const handleCsvData = (rows, currentScene, currentMedia, dispatch) => {
    let promises = rows.map(row => {
        // Decide if the object exists in the redux store already.
        let alreadyExists = _.find(currentMedia, current => current.sceneMediaID === row.sceneMediaID);

        // Build the payload for the probable request
        const payload = {
            mediaPath:       row.sourcePath,
            mediaRepository: row.sourceRepository,
            mediaName:       row.mediaName,
            datasetNum:      parseInt(row.datasetNum, 10),
            language:        row.language
        };

        // Start building the result for when we decide what to do with the row
        let result = {
            item: row,
            error: ''
        };

        if (alreadyExists) {            
            if (compareRowAndMediaItem(row, alreadyExists)) {
                // If it already exists, and it is the same as what is in the redux store its a noop
                Object.assign(result, {type: NOOP_IMPORTED_ITEM});
                return dispatch(addCsvProvessingResult(result));

            } else {
                // If it already exists, and it is different than what is in the redux store, perform an update
                Object.assign(result, {type: UPDATE_IMPORTED_ITEM});
                return importAction(() => updateMedia(currentScene, row.sceneMediaID, payload), result, dispatch);

            }
        } else {
            // If it does not already exist, then try to add it
            Object.assign(result, {type: NEW_IMPORTED_ITEM});
            return importAction(() => addMedia(currentScene, payload), result, dispatch);
        }
    });

    // Wait for all the csv processing medias to come back
     return Promise.all(promises);
};

const compareRowAndMediaItem = (csvItem, existingItem) => {
    return csvItem.sourcePath === existingItem.sourcePath
        && csvItem.sourceRepository === existingItem.sourceRepository
        && csvItem.sceneMediaID === existingItem.sceneMediaID
        && csvItem.sceneName === existingItem.sceneName
        && csvItem.datasetNum === existingItem.datasetNum
        && csvItem.mediaName === existingItem.mediaName
        && csvItem.language === existingItem.language;
};

const importAction = (action, result, dispatch) => {
    return action()(dispatch)
        .then(
            () => dispatch(addCsvProvessingResult(result)),
            err => dispatch(addCsvProvessingResult(Object.assign(result, {error: err})))
        );
}

const processCsv = (file, currentScene, currentMedia) => (dispatch) => {
    dispatch(startCsvProcessing());

    return readFile(file)
        .then(parseCsvRows)
        .then(results => {
            dispatch(initializeCsvProcessingResults(results.data.length));
            return results.data;
        })
        .then(rows => handleCsvData(rows, currentScene, currentMedia, dispatch))
        .then(() => dispatch(endCsvProcessing()));
};

export const processCsvIfOK = file => (dispatch, getState) => {
    const state = getState();
    const currentScene = state.scene.current;
    
    if (canHandleProcessing(state.ui.upload)) {
        // Get the freshest media possible. Then process the csv.
        return dispatch(fetchMediaIfOK(currentScene, true))
            .then(() => getState().mediaByScene[currentScene].mediaItems)
            .then(currentMedia => dispatch(processCsv(file, currentScene, currentMedia)))
            .catch(err => {
                dispatch(endCsvProcessing());
                dispatch(displayError(err));
            });
        }
};



// WEBPACK FOOTER //
// ./src/actions/uploadCsv.js